<template>
    <div class="chat__contact flex items-center px-2 pt-4 pb-2" :class="{activeChat:isThreadActive}" 
    @click="handleActiveThread(thread.user_id, thread)">
    <!-- {{ thread.last_message_details.message.split('/').pop() }} -->
    <!-- {{ thread.last_message_details.is_attachment }} -->
    <!-- <pe>{{thread.user_id}}</pe> -->
        <div class="contact__avatar mr-1">
            <vs-avatar class="border-2 border-solid border-white" :src="thread.picture" size="40px" />
        </div>
        <div class="contact__container flex items-center justify-between overflow-hidden" style="width:100%;">
            <div class="contact__info flex flex-col truncate w-4/6">
                <h5 style="font-size: 14px;" class="font-semibold">{{ thread.first_name }} {{ thread.last_name }}</h5>
                <div v-if=" thread.last_message_details && thread.last_message_details.message_time !== '' && Number(thread.last_message_details.is_attachment) === 1" >
                  <span v-if="thread.last_message_details && thread.last_message_details.message_time !== ''" class="truncate">
                    {{ thread.last_message_details.message.split('/').pop() }}
                  </span>
                </div>
                <div v-else>
                  <span v-if="thread.last_message_details && thread.last_message_details.message_time !== ''" class="truncate">
                    {{ thread.last_message_details.message }}
                  </span>
                </div>
            </div>
        </div>
        <div class="chat__contact__meta flex self-end justify-end flex-col items-end w-2/6">
                <!-- <p class="whitespace-no-wrap" style="text-align:right;font-size:11px;">{{ thread.last_message_details.message_time | moment("dddd, MMMM Do") }}</p> -->

                <p v-if="thread.last_message_details && thread.last_message_details.message_time !== ''" class="whitespace-no-wrap" style="text-align:right;font-size:11px;">{{ thread.last_message_details.message_time | moment("from") }}  </p>
                <!-- <vs-chip class="number" color="primary">{{ unseenMsg }}</vs-chip> -->
            </div>
    </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import { fetchChatHistory, readChatMessage } from '@/api/message'
import {messageMixin} from './mixin/messageMixin'
import {EventBus} from './mixin/EventBus'

export default {
  data () {
    return {
      lastMessageDate:''
    }
  },
  props: {
    thread: {
      type:Object,
      required: true
    },
    fetchChat:{}
  },
  mixins: [messageMixin],
  computed: {
    ...mapGetters(['ChatRelatedTo', 'UserThreadsGeneral', 'ClientThreadsGeneral', 'UserActiveThread', 'ClientActiveThread', 'tabActive', 'SingleActiveThreadDetails']),
    isThreadActive () {
      if (this.tabActive === 0) {
        if (this.UserActiveThread === this.thread.user_id) {
          return true
        }
      } else if (this.tabActive === 1) {
        if (this.ClientActiveThread === this.thread.user_id) {
          return true
        }
      }
      // if (this.active_thread === this.thread.user_id) {
      //   return true
      // }
    },
    getLastMessageDate () {
      // let dateTime = ''
      // if (this.$moment.unix(this.thread.message_time).isSame(new Date(), 'day')) {
      //   dateTime = this.$moment.unix(this.thread.message_time).format('h:mm a')
      // } else if (this.$moment.unix(this.thread.message_time).isSame(new Date(), 'week')) {
      //   dateTime = this.$moment.unix(this.thread.message_time).format('ddd')
      // } else {
      //   dateTime = this.$moment.unix(this.thread.message_time).format('MMM D YYYY')
      // }
      return this.lastMessageDate
    }
  },
  mounted () {

    let user_id = ''
    if (this.tabActive === 0 || this.tabActive === 1) {
      user_id = this.SingleActiveThreadDetails.user_id
    }
    if (user_id && this.fetchChat) {
      this.handleActiveThread(user_id, null)
    }

    if (!user_id && this.fetchChat) {
      if (this.UserThreads.length > 0) {
        this.handleActiveThread(this.UserThreadsGeneral[0].user_id, this.UserThreadsGeneral[0])
      } else if (this.ClientThreads.length > 0) {
        this.handleActiveThread(this.ClientThreadsGeneral[0].user_id, this.ClientThreadsGeneral[0])
      }
    }
  

  },
  methods: {
    ...mapActions(['SET_USER_ACTIVE_THREAD', 'SET_CLIENT_ACTIVE_THREAD', 'SET_ACTIVE_SINGLE_THREAD_DETAILS']),
    async handleActiveThread (user_id, thread) {
      try {
        // 
        let group_id = null
        let to_user_type = ''
        if (this.tabActive === 0) {
          to_user_type = 'User'
          this.SET_USER_ACTIVE_THREAD(user_id)
        } else if (this.tabActive === 1) {
          to_user_type = 'Client'
          this.SET_CLIENT_ACTIVE_THREAD(user_id)
        } else if (this.tabActive === 2) {
          group_id = user_id
          this.SET_GROUP_ACTIVE_THREAD(group_id)
        } 
        // 
        const payload = {
          another_user_id : user_id,
          from_user_type : 'User',
          group_id,
          last_id : null,
          to_user_type,
          is_client_message_type: this.ChatRelatedTo,
          customer_id:localStorage.getItem('customer_id')
        }
        const { data } = await fetchChatHistory(payload)
        // 

        const payload2 = {
          to_user : user_id,
          from_user_type : 'User',
          to_user_type
        }

        const data2 = await readChatMessage(payload2)
        EventBus.$emit('readChatMessageEvent')
        
        
        if (thread !== null) {
          this.SET_ACTIVE_SINGLE_THREAD_DETAILS(thread)
        }
        
        // EventBus.$off('singleChatClicked')
        EventBus.$emit('singleChatClicked', data.data)
      } catch (e) {
        
      }
      
    }
  }
}
</script>
<style scoped>
.activeChat {
  background-color: rgba(var(--vs-primary), 0.6);
}
</style>

